import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconX = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5859 12.0001L7.29297 15.293L8.70718 16.7072L12.0001 13.4143L15.293 16.7072L16.7072 15.293L13.4143 12.0001L16.7072 8.70718L15.293 7.29297L12.0001 10.5859L8.70718 7.29297L7.29297 8.70718L10.5859 12.0001Z"
        />
      </svg>
    );
  }
);
